import { render, staticRenderFns } from "./top-main.vue?vue&type=template&id=0f908484&scoped=true"
import script from "./top-main.vue?vue&type=script&lang=js"
export * from "./top-main.vue?vue&type=script&lang=js"
import style0 from "./top-main.vue?vue&type=style&index=0&id=0f908484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f908484",
  null
  
)

export default component.exports